export const cellFlex = {
  link: 2.25,
  teacherPresent: 2.75,
  id: 2.5,
  teacherName: 2,
  w2wID: 1.75,
  role: 1,
  studentNames: 3,
  classBegin: 1.5,
  teachingTime: 2,
  title: 2,
  language: 1.5,
  levelId: 1.25,
} as {
  [key: string]: number;
};
